import { useNavigate } from "react-router-dom";

import ConfirmationQuestion from "../../../components/Questions/ConfirmationQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { questionContent } from "../questions";

const Age: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (newAnswers: ConfirmationAnswer) => {
    setAnswers({
      ...answers,
      age: newAnswers,
      ...(newAnswers !== ConfirmationAnswer.Yes
        ? {
            ageDetail: undefined,
            ageCare: undefined,
          }
        : {}),
    });
  };

  const onContinue = () => {
    if (answers.age === ConfirmationAnswer.Yes) {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.AgeDetail}`);
    } else {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.MedicalEquipment}`);
    }
  };

  return (
    <ConfirmationQuestion
      onChange={onChange}
      value={answers.age}
      onContinue={onContinue}
      step={questionContent.age.step}
      title={questionContent.age.title}
      subTitle={questionContent.age.subTitle}
      whyWeWantTexts={questionContent.age.whyWeWantTextsCustomer}
    />
  );
};

export default Age;
